import { render, staticRenderFns } from "./ModalVideoLinks.vue?vue&type=template&id=ba9b3a4c&scoped=true"
import script from "./ModalVideoLinks.vue?vue&type=script&lang=js"
export * from "./ModalVideoLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9b3a4c",
  null
  
)

export default component.exports